import * as angular from 'angular';
import * as _ from 'lodash';

import { IStateService } from '../../services';
import { State, StateDto } from '../../models';
import { Store } from '../Store';
import * as STATES from './states.constants';

import {
    loadStates,
    loadStatesSuccess,
    deleteState,
    updateStateSuccess,
    updateState
} from './states.actions';


export interface IStateActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<State>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<State[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<State[]>;
    addOne(target: StateDto): (dispatch: any, getState: () => Store) => angular.IPromise<State[]>;
    updateOne(target: StateDto): (dispatch: any, getState: () => Store) => angular.IPromise<State[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<State[]>;
}

export class StateActionsService implements IStateActionsService {
    static serviceId = 'stateActionsService';
    static $inject = ['$q', 'stateService'];


    constructor(
        private _$q: angular.IQService,
        private _stateService: IStateService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { states } = getState();
            if (!states.isLoading && !states.isLoaded) {
                dispatch(loadStates());
                return this._stateService
                    .getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.state.guid === guid);
                        dispatch(loadStatesSuccess(result.map(d => d.state)));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: STATES.STATES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<State>(states.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { states } = getState();
            if (force || (!states.isLoading && !states.isLoaded)) {
                dispatch(loadStates());
                return this._stateService
                    .getAll(force)
                    .then(data => {
                        dispatch(loadStatesSuccess(data.map(d => d.state)));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: STATES.STATES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<State>(states.dictionary));
            }
        };
    }

    addOne(target: StateDto) {
        return this.updateOne(target);
    }

    updateOne(target: StateDto) {
        return (dispatch: any, getState: () => Store) => {
            dispatch(updateState(target.state));
            return this._stateService
                .updateOne(target)
                .then(data => {
                    const result = data;
                    dispatch(updateStateSuccess(result.state));
                    return result;
                })
                .catch((reason) => {
                    dispatch({ type: STATES.STATE_UPDATE_ERROR, payload: reason });
                    return reason;
                });

        };
    }

    deleteOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            dispatch(deleteState(guid));
            return this._stateService
                .deleteOne(guid)
                .then(data => {
                    dispatch({ type: STATES.STATE_DELETE_SUCCESS, payload: guid });
                    return dispatch(this.getAll(true));
                })
                .catch((reason) => {
                    dispatch({ type: STATES.STATES_DELETE_ERROR, payload: reason });
                    return reason;
                });
        };
    }
}